import {
  Component,
  OnInit,
  ViewChild,
  Input,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import * as moment from "moment";
import { BehaviorSubject, Subscription, Subject } from "rxjs";
// import {
//   NgbActiveModal, NgbModal
// } from '@ng-bootstrap/ng-bootstrap';
import { Signaltag } from "../../models/trend-live-models/OPTag";
import { TagsService } from "../../providers/trend-live-services/tags.service";

import {
  DEFAULT_TIME_FORMAT,
  TimeRange,
} from "../../models/trend-live-models/TimeRange";
import { CHART_COLORS } from "../../providers/trend-live-services/chartColors";
import { SignalTagsDs } from "./LegendDataSource";
import { TagsFilterComponent } from "./tags-filter/tags-filter.component";
import { Train } from "../../models/trend-live-models/train";
import { AdvancedFilters } from "./tags-filter/AdvancedFilters";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
// import { SPINNER_CONFIG } from 'src/app/shared/spinner-config';
// import { NavService } from 'src/app/core/services/nav.service';
import { LdsClientService } from "../../providers/lds-client/lds-client.service";
import { TrendExplorerService } from "./trend-explorer.service";
import { map } from "rxjs/operators";
import { roundedToFixed } from "../../providers/trend-live-services/round";
import * as Plotly from "plotly.js";
import { Content, ModalController, NavParams } from "ionic-angular";
import { Output, EventEmitter } from "@angular/core";
import { TimeProvider } from "../../providers/time/time";
import { TrendExplorerTagListComponent } from "../trend-explorer-tag-list/trend-explorer-tag-list";

@Component({
  selector: "app-trend-explorer",
  templateUrl: "./trend-explorer.component.html",
})
export class TrendExplorerComponent implements OnInit, OnDestroy {
  @Output() loadedData = new EventEmitter<boolean>();
  @Input() set InitialTrain(value: {
    tag: Signaltag;
    tags: Signaltag[];
    subscription: string;
  }) {
    if (value) {
      this.initialTrainChanges.next(value);
    }
  }
  @Input() set initialTag(value: {
    tag: Signaltag;
    tags: Signaltag[];
    subscription: string;
  }) {
    if (value) {
      this.initialTagChanges.next(value);
    }
  }
  @ViewChild("chartEl", { read: ElementRef }) chartEl: ElementRef;
  @ViewChild(Content) content: Content;
  initialTagChanges = new BehaviorSubject<{
    tag: Signaltag;
    tags: Signaltag[];
    subscription: string;
  }>(undefined);
  initialTrainChanges = new BehaviorSubject<any>(undefined);
  timeRangeChanged = new BehaviorSubject<TimeRange>(undefined);
  timeR = [
    { value: 1, type: "h" },
    { value: 6, type: "h" },
    { value: 1, type: "d" },
    { value: 1, type: "w" },
    { value: 1, type: "M" },
    { value: 3, type: "M" },
    { value: 1, type: "Y" },
  ];
  layout = {
    dragMode: false,
    font: { size: 10 },
    height: 200,
    margin: {
      l: 20,
      r: 20,
      b: 0,
      t: 0,
      pad: 0,
    },
    showLegend: false,
    paper_bgcolor: "white",
    plot_bgcolor: "white",
    hovermode: "x",
    hoverdistance: 100, // Distance to show hover label of data point
    spikedistance: 1000,
    xaxis: {
      type: "date",
      automargin: true,
      showspikes: true,
      showgrid: true,
      visible: true,
      autorange: true,
      // rangeselector: selectorOptions,
    },
    yaxis: {
      visible: true,
      automargin: true,
      fixedrange: true,
      showticklabels: true,
      showgrid: true,
      zeroline: false,
      showline: true,
      side: "right",
      tickvals: [],
      autorange: true,
    },
  };
  traceIndex = 0;
  chartUpdateInterval;
  colors = CHART_COLORS;
  tagsQuery: any;
  tagsFilter = null;
  individualScaling = false;
  showEventsFlags = false;
  restoreTags: Signaltag[] = [];
  trainTags: Signaltag[] = [];
  customLabelTxt = "CUSTOM";
  selectedButton = "1d";

  tagsReady = false;
  train: Train;

  timeZone: string;
  currentTime;

  realTimeEnabled = true;

  // spinnerConfig = SPINNER_CONFIG;
  activeRequests = 0;

  legend = new SignalTagsDs();
  legendColumns = ["color", "tagAlias", "visibility", "control"];
  tagsColumns = ["tagAlias", "lastValue", "time"];
  timeRanges: TimeRange[] = [new TimeRange(1, "d", false)];
  tagsNewValuesSub: Subscription[] = [];

  ldsStream;

  txReady = false;
  /**
   * Tags
   *
   */
  tagsList = new SignalTagsDs();

  eventsFlags = new Signaltag().deserialize({
    tagAlias: "Events Flags",
    isEvent: true,
  });

  filters: any;
  nFilters = new AdvancedFilters<Signaltag>([
    {
      extractProperty: (t: Signaltag) => t.engUnit,
      value: [],
      type: "multicheck",
      filterName: "engUnit",
    },
  ]);

  historicalDataResolution = [
    {
      name: "Hourly",
      value: "hourly",
    },
    {
      name: "Raw (Low Perfromance)",
      value: "all",
    },
    {
      name: "Optim max 200 points",
      value: "optim:200",
    },
    {
      name: "Optim max 600 points",
      value: "optim:600",
    },
  ];

  selectedHistoricalDataResolution = {
    name: "Hourly",
    value: "hourly",
  };

  disableLive = false;

  chartCreated = false;
  chartTracesUpdate$ = new Subject<any[]>();

  tagsLDSSub;

  pauseRealTime = false;

  config;

  constructor(
    // public activeModal: NgbActiveModal,
    private tags: TagsService,
    // private modal: NgbModal,
    private starmsClient: StarmsClientProvider,
    public nav: NavParams,
    private lds: LdsClientService,
    private txServ: TrendExplorerService,
    private time: TimeProvider,
    public modalCtrl: ModalController
  ) {}

  ngOnInit() {
    this.initialTrainChanges.subscribe((current) => {
      this.train = current as Train;
      this.fetchConfig(current.getId());
      this.updateTime(1, "M");
    });
  }

  ngOnDestroy() {
    if (this.ldsStream) {
      this.ldsStream.unsubscribe();
    }
  }

  changeHistoricalResolution(input: { value: string; name: string }) {
    this.selectedHistoricalDataResolution = input;
  }

  scrollToTop() {
    this.content.scrollToTop();
  }
  presentTagListModal() {
    let profileModal = this.modalCtrl.create(
      TrendExplorerTagListComponent,
      this.trainTags
    );
    profileModal.present();
  }
  /**
   * Update time range and apply it
   * @param value new time range value
   */
  updateTime(value, type) {
    this.selectedButton = value + type;
    this.timeRanges = [new TimeRange(value, type, false)];
    this.applyTimeRange();
  }

  initializeItems() {
    this.trainTags = this.restoreTags;
  }
  getItems(ev) {
    // Reset items back to all of the items
    this.initializeItems();

    // set val to the value of the ev target
    var val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != "") {
      this.trainTags = this.trainTags.filter((item) => {
        return item.tagName.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
      this.sortTagsByAdded();
    }
    this.sortTagsByAdded();
  }
  fetchConfig(trainId: number) {
    this.txServ.fetchConfig(trainId).subscribe((config) => {
      console.log(
        "🚀 ~ file: trend-explorer.component.ts ~ line 279 ~ TrendExplorerComponent ~ this.txServ.fetchConfig ~ config",
        config
      );
      this.config = config;

      this.timeZone = config.timezone;
      this.trainTags = config.tags;
      // this.activeRequests--;
      this.restoreTags = this.trainTags;
      this.trainTags = this.trainTags.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.tagId == value.tagId)
      );
      this.tagsReady = true;
      // this.createChart();
      if (this.timeZone) {
        this.legendColumns = [
          "tagAlias",
          "lastValue",
          "time",
          "visibility",
          "control",
        ];
      }
      this.initialTagChanges.subscribe((data) => {
        if (data) {
          if (data.tag) {
            const index = this.trainTags.findIndex(
              (tag) => tag.tagId === data.tag.tagId
            );
            if (index > -1) {
              this.fetchEvents(this.train);
              this.toggleTag(this.trainTags[index]);
              this.loadedData.emit(true);
            }
          }
        }
      });
      this.watchChartTracesUpdate();
      if (config.dataSource) {
        // this.watchLiveData();
      }
    });
  }

  watchLiveData() {
    this.lds.socketReady.subscribe((ready) => {
      if (ready) {
        this.lds
          .createStreamingSubscription(this.config.dataSource)
          .subscribe((subscription) => {
            this.tagsLDSSub = subscription.subscriptionId;
            this.ldsStream = this.lds.stream
              .pipe(
                map((stream) => {
                  for (const tag of stream.value.responses) {
                    let jsTzDate = new Date(
                      tag.origin as number
                    ).toLocaleString("en-US", {
                      timeZone: this.config.timezone,
                    });
                    let momentTzDate = moment(new Date(jsTzDate).getTime());

                    tag.origin = Date.parse(
                      moment
                        .utc(momentTzDate.format("YYYY-MM-DD HH:mm:ss"))
                        .format()
                    );
                  }
                  return stream;
                })
              )
              .subscribe((stream) => {
                if (
                  stream &&
                  stream.subscriptionId === this.tagsLDSSub &&
                  stream.value.responses.length
                ) {
                  this.trainTags.forEach((tag) => (tag.realTime = false));
                  if (this.realTimeEnabled) {
                    const update = {
                      x: [],
                      y: [],
                    };
                    const toUpdateIndices = [];

                    const traceTags = this.getTraces().map(
                      (t) => t.txMeta.tagId
                    );
                    const addedTags = this.restoreTags.filter(
                      (tag) => traceTags.indexOf(tag.tagId) > -1
                    );
                    for (let tag of this.trainTags) {
                      const index = stream.value.responses.findIndex(
                        (streamTag) => streamTag.tag === tag.tagName
                      );

                      if (index > -1) {
                        tag.trendExplorer.originalTimeStamp =
                          stream.value.responses[index].origin;

                        tag.trendExplorer.lastTimeStamp = moment(
                          this.tags.toTimezone(
                            stream.value.responses[index].origin,
                            this.config.timezone
                          )
                        ).format(DEFAULT_TIME_FORMAT);
                        tag.trendExplorer.lastValue = Number(
                          roundedToFixed(stream.value.responses[index].value, 4)
                        );
                      } else {
                        if (tag.trendExplorer.originalTimeStamp) {
                          tag.trendExplorer.lastTimeStamp = moment(
                            this.tags.toTimezone(
                              tag.trendExplorer.originalTimeStamp,
                              this.config.timezone
                            )
                          ).format(DEFAULT_TIME_FORMAT);
                        }
                      }
                    }
                    for (const tag of addedTags) {
                      const index = stream.value.responses.findIndex(
                        (streamTag) => streamTag.tag === tag.tagName
                      );
                      if (index > -1) {
                        tag.trendExplorer.originalTimeStamp =
                          stream.value.responses[index].origin;

                        tag.trendExplorer.lastTimeStamp = moment
                          .utc(stream.value.responses[index].origin)
                          .format();
                        tag.trendExplorer.lastValue = Number(
                          roundedToFixed(stream.value.responses[index].value, 4)
                        );
                        let tagIndex = this.trainTags.indexOf(tag);
                        this.trainTags[tagIndex].trendExplorer.lastValue =
                          Number(
                            stream.value.responses[index].value.toFixed(4)
                          );

                        this.trainTags[tagIndex].trendExplorer.lastTimeStamp =
                          moment
                            .utc(stream.value.responses[index].origin)
                            .format()
                            .replace("T", " ")
                            .replace("Z", "");

                        if (!tag.trendExplorer.loading) {
                          update.x.push([
                            moment
                              .utc(stream.value.responses[index].origin)
                              .format(),
                          ]);
                          update.y.push([
                            Number(
                              stream.value.responses[index].value.toFixed(4)
                            ),
                          ]);
                          toUpdateIndices.push(tag.trendExplorer.traceIndex);
                        }
                      } else {
                        if (tag.trendExplorer.originalTimeStamp) {
                          // let jsTzDate = new Date(
                          //   tag.trendExplorer.originalTimeStamp as number
                          // ).toLocaleString("en-US", {
                          //   timeZone: this.config.timezone,
                          // });
                          // let momentTzDate = moment(
                          //   new Date(jsTzDate).getTime()
                          // ).format("YYYY-MM-DD HH:mm:ss");
                          tag.trendExplorer.lastTimeStamp = moment
                            .utc(tag.trendExplorer.originalTimeStamp)
                            .format()
                            .replace("T", " ")
                            .replace("Z", "");
                        }
                      }
                    }

                    if (toUpdateIndices.length && !this.disableLive) {
                      Plotly.extendTraces(
                        this.chartEl.nativeElement,
                        update,
                        toUpdateIndices
                      );
                    }
                  }
                }
              });
          });
      }
    });
  }

  /**
   * Create the main trend explorer chart
   */
  createChart() {
    let self = this;

    for (let i = 0; i < this.restoreTags.length; i++) {
      this.layout["yaxis" + (i + 2)] = {
        overlaying: "y",
        automargin: true,
        fixedrange: true,
        showticklabels: false,
        showgrid: false,
        zeroline: false,
        showline: true,
        tickvals: [],
        //position: 0.1 * (i)
      };
    }

    const config = {
      responsive: true,
      displaylogo: false,
      modeBarButtons: [[]],
      scrollZoom: true,
      doubleClick: false,
    };

    Plotly.newPlot(this.chartEl.nativeElement, [], this.layout, config);

    this.chartEl.nativeElement.on("plotly_relayout", (eventData) => {
      // this.tags.cancelTrendExplorerRequests();
      if (eventData["xaxis.range[0]"]) {
        var fromDate = eventData["xaxis.range[0]"];
        var toDate = eventData["xaxis.range[1]"];
        var months = "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(
          " "
        );
        if (fromDate.substring(0, 10) == toDate.substring(0, 10)) {
          this.customLabelTxt =
            fromDate.substring(8, 10) +
            " " +
            months[fromDate.substring(5, 7) - 1] +
            " " +
            fromDate.substring(0, 4);
        } else {
          this.customLabelTxt =
            fromDate.substring(8, 10) +
            " " +
            months[fromDate.substring(5, 7) - 1] +
            " " +
            fromDate.substring(0, 4) +
            " - " +
            toDate.substring(8, 10) +
            " " +
            months[toDate.substring(5, 7) - 1] +
            " " +
            toDate.substring(0, 4);
        }
        this.selectedButton = "custom";

        this.timeRanges.push(new TimeRange(fromDate, toDate, false));

        this.disableLive = true;
        this.applyTimeRange();
      }
    });
  }

  /**
   * Emmit an internal trend explorer event representing that chart traces were updated
   */
  private emitChartTracesUpdate() {
    try {
      // Cast to a temp type which contains only relevant data
      const foundTraces = this.chartEl.nativeElement.data as Array<{
        txMeta: { tagId: number };
      }>;

      // Emmit current traces
      this.chartTracesUpdate$.next(foundTraces);
    } catch (e) {
      console.log("Cannot emmit the chart traces update event");
    }
  }

  private watchChartTracesUpdate() {
    this.chartTracesUpdate$.subscribe(
      (traces: Array<{ txMeta: { tagId: number } }>) => {
        // for legend, keep only the tags that are currently displayed on chart, based on current traces

        const legendTags = this.restoreTags.filter(
          (tag) => traces.map((t) => t.txMeta.tagId).indexOf(tag.tagId) > -1
        );

        this.legend.change(legendTags);
      },
      () => {
        // do nothing
      }
    );
  }

  /**
   * Get the number of traces from the chart
   */
  private getTracesNumber() {
    let result = 0;
    try {
      if (this.chartEl.nativeElement.data) {
        result = this.chartEl.nativeElement.data.length;
      }
    } catch (e) {
      console.log(e);
    }
    return result;
  }

  private findTraceIndexByTagId(tagId: number) {
    const traces = this.chartEl.nativeElement.data as Array<{
      txMeta: { tagId: number };
    }>;
    return traces.findIndex((trace) => trace.txMeta.tagId === tagId);
  }

  getTraces() {
    return this.chartEl.nativeElement.data as Array<{
      txMeta: { tagId: number };
      line: { color: string };
    }>;
  }

  /**
   * Add new trace to the chart
   * @param traceConfig trace object
   * @param traceIndex trace index
   */
  private addChartTrace(traceConfig: any, traceIndex?: number) {
    try {
      const tagId = traceConfig[0].txMeta.tagId;

      const addTraceResult = Plotly.addTraces(
        this.chartEl.nativeElement,
        traceConfig,
        traceIndex
      ) as Promise<any>;

      addTraceResult
        .then(() => {
          // Emmit chart trace update event
          this.emitChartTracesUpdate();
        })
        .catch((e) => {
          this.activeRequests--;

          console.log(e);
        });
    } catch (e) {
      this.activeRequests--;

      // error toast message
      console.log(e);
    }
  }

  /**
   * Remove a trace from the chart
   * @traceIndex index of the trace that will be removed
   */
  private deleteChartTrace(traceIndex: number) {
    Plotly.deleteTraces(this.chartEl.nativeElement, traceIndex);
  }

  /**
   * Fetch tag entries using the current time range and add new trace to chart
   * @param tag tag object
   */
  private fetchTag(tag: Signaltag): void {
    // Push the tag into the recently viewd tags list for further sesions
    this.updateRecentlyViewed(tag);
    tag.trendExplorer.loading = true;
    this.activeRequests++;
    // Fetch tag and keep subscription ref for further cancelation
    tag.trendExplorer.dataSub = this.tags
      .fetch(
        tag,
        this.timeRanges[this.timeRanges.length - 1],
        { value: "optim", name: "optim" },
        true
      )
      .subscribe(
        (tagEntries) => {
          const tracesNo = this.getTracesNumber();

          const existingTraceIndex = this.findTraceIndexByTagId(tag.tagId);

          const ticks = this.legend.data
            .getValue()
            .map((x) => x.trendExplorer.lastValue);

          // If tag not plotted yet
          if (existingTraceIndex < 0) {
            const color =
              tag.trendExplorer.traceColor !== null
                ? tag.trendExplorer.traceColor
                : this.colors[(tracesNo % this.colors.length) - 1];

            /**
             * Create a new trace object
             */
            const trace = [
              {
                x: [
                  ...tagEntries.map((t) =>
                    moment.utc(t.timestamp).format("YYYY-MM-DD HH:mm:ss")
                  ),
                ],
                y: [...tagEntries.map((t) => t.value)],
                mode: "lines",
                type: "scatter",
                // yaxis: tracesNo === 0 ? 'y' : `y${tracesNo}`,
                line: {
                  color: color,
                },
                name: tag.displayName,
                showlegend: false,

                // hovertemplate: '%{x} <br /> %{y} ' + (tag.engUnit ? tag.engUnit : ''),
                txMeta: {
                  tagId: tag.tagId,
                },
              },
            ];

            if (this.individualScaling) {
              if (tracesNo > 0) {
                trace[0]["yaxis"] = `y${tracesNo + 1}`;
              }
            } else {
              trace[0]["yaxis"] = "y";
            }

            tag.trendExplorer.traceColor = color;
            tag.trendExplorer.traceIndex = tracesNo;

            // Legend update
            this.addChartTrace(trace, tag.trendExplorer.traceIndex);
            this.sortTagsByAdded();
            // Update last value and last timestamp for the added tag
            const lastEntry = tagEntries
              .reverse()
              .find((e) => e.value !== null);
            if (lastEntry) {
              tag.trendExplorer.lastValue = Number(lastEntry.value.toFixed(4));
              tag.trendExplorer.lastTimeStamp = moment
                .utc(lastEntry.timestamp)
                .format("YYYY-MM-DD HH:mm:ss");
            }
            Plotly.update(this.chartEl.nativeElement, undefined, {
              // 'yaxis.tickvals': [...ticks, tag.trendExplorer.lastValue]
            }).then(() => {
              this.activeRequests--;
            });
            this.scrollToTop();
          } else {
            // If tag already plotted
            let update = {
              x: [[...tagEntries.map((t) => moment.utc(t.timestamp).format())]],
              y: [[...tagEntries.map((t) => t.value)]],
            };
            Plotly.update(
              this.chartEl.nativeElement,
              update,
              {
                // 'yaxis.tickvals': [...ticks, tag.trendExplorer.lastValue]
              },
              existingTraceIndex
            ).then(() => {
              this.activeRequests--;
            });
          }
          this.txReady = true;

          tag.trendExplorer.loading = false;
          this.scrollToTop();
        },
        (error) => {
          console.log("Tag error", error);
          this.activeRequests--;
        }
      );
  }

  /**
   * Toggle tag (add/remove)
   * @param tag tag to be toggled
   */
  toggleTag(tag: Signaltag): void {
    if (tag.trendExplorer.traceIndex === null) {
      this.fetchTag(tag);
      // this.addTagToStart(tag);
    } else {
      const traceIndex = this.findTraceIndexByTagId(tag.tagId);
      if (traceIndex > -1) {
        // Cancel active subscriptions
        if (tag.trendExplorer.dataSub) {
          (tag.trendExplorer.dataSub as Subscription).unsubscribe();
        }

        // Remove trace and emmit change event
        this.deleteChartTrace(traceIndex);
        this.emitChartTracesUpdate();

        tag.trendExplorer.traceColor = null;
        tag.trendExplorer.traceIndex = null;
        // this.trainTags = this.restoreTags;
        this.trainTags = this.restoreTags;
        this.toggleIndividualScaling(this.individualScaling);
      }
    }
  }

  addTagToStart(firstTag) {
    this.trainTags.sort(function (x, y) {
      return x == firstTag ? -1 : y == firstTag ? 1 : 0;
    });
  }

  sortTagsByAdded() {
    this.trainTags.sort((a, b) => {
      let aIsAdded = a.trendExplorer.traceColor !== null;
      let bIsAdded = b.trendExplorer.traceColor !== null;
      return Number(bIsAdded) - Number(aIsAdded);
    });
  }

  /**
   * Update recently viewed tags list for further sessions
   * @param tag tag to be stored
   */
  updateRecentlyViewed(tag: Signaltag) {
    const recentTags = localStorage.getItem("recentTags");
    if (recentTags) {
      try {
        let data = JSON.parse(recentTags);
        data.push(tag.tagId);
        data = (data as Array<number>).reverse().slice(0, 100).reverse();
        localStorage.setItem("recentTags", JSON.stringify(data));
      } catch (e) {
        console.log(e);
      }
    } else {
      localStorage.setItem("recentTags", JSON.stringify([tag.tagId]));
    }
  }

  /**
   * Searchbox query changed event handler
   */
  queryChanged() {
    this.filterTags();
  }

  /**
   * Apply current filters including the searchbox query
   */
  filterTags() {
    this.trainTags = this.restoreTags;
    if (this.tagsQuery) {
      const result = this.trainTags.filter(
        (v) =>
          v.tagName.toLowerCase().indexOf(this.tagsQuery.toLowerCase()) > -1 ||
          v.tagDescription.toLowerCase().indexOf(this.tagsQuery.toLowerCase()) >
            -1
      );
      this.trainTags = result;
    }

    if (this.filters !== undefined && this.filters !== null) {
      const filtersValue = this.filters.filters.slice();
      const activeFilters = filtersValue
        .map((entry) => {
          const newEntry = Object.assign({}, entry);
          newEntry.options = entry.options
            .filter((opEntry) => opEntry.value === true)
            .map((x) => x.filterOptionName);
          return newEntry;
        })
        .filter((entry) => entry.options.length);

      this.trainTags = this.trainTags.filter((tag) => {
        let keepTag = true;
        for (const item of activeFilters) {
          if (item.options.indexOf(tag[item.filterName]) < 0) {
            keepTag = false;
          }
        }
        return keepTag;
      });
    }
  }

  /**
   * Toggle chart serie visbility for a tag
   * @param tag tag object
   */
  toggleTagVisibility(tag: Signaltag) {
    tag.trendExplorer.visible = !tag.trendExplorer.visible;
    const traces = this.getTraces();

    let index = traces.findIndex((trace) => trace.txMeta.tagId === tag.tagId);
    if (index > -1) {
      (traces[index] as any).visible = tag.trendExplorer.visible;
    }
    Plotly.redraw(this.chartEl.nativeElement);
  }

  /**
   * Apply selected time range
   */
  applyTimeRange(): void {
    this.traceIndex = 0;

    // Recreate the chart
    //this.createChart();

    const addedTags = this.restoreTags.filter(
      (tag) => tag.trendExplorer.traceIndex !== null
    );
    for (const tag of addedTags) {
      if (tag.trendExplorer.dataSub) {
        (tag.trendExplorer.dataSub as Subscription).unsubscribe();
      }
    }
    // this.activeRequests = 0;
    for (const tag of addedTags) {
      this.fetchTag(tag);
    }
    Plotly.purge(this.chartEl.nativeElement);
    this.createChart();
    this.fetchEvents(this.train);
  }

  changeTraceColor(color: string, tag: Signaltag) {
    const existingTraceIndex = this.findTraceIndexByTagId(tag.tagId);
    Plotly.update(
      this.chartEl.nativeElement,
      { "line.color": tag.trendExplorer.traceColor },
      undefined,
      existingTraceIndex
    );
  }
  /**
   * Toggle individual scaling for tags
   * Display tags in separated yAxis or on the same yAxis
   * @param option whether individual scaling is enabled
   */
  toggleIndividualScaling(option: any) {
    this.individualScaling = option.checked;
    let currentTraces = this.chartEl?.nativeElement.data;
    if (currentTraces) {
      for (let i = 0; i < currentTraces.length; i++) {
        if (this.individualScaling) {
          currentTraces[i]["yaxis"] = `y${i + 1}`;
          this.layout.yaxis.visible = false;
          this.layout.yaxis.autorange = true;
          this.layout.xaxis.autorange = true;

          if (currentTraces.length > 1) {
            this.layout["yaxis" + (i + 1)] = {
              visible: false,
              autorange: true,
              overlaying: "y",
            };
          }
        } else {
          currentTraces[i]["yaxis"] = "y";
          this.layout.yaxis.visible = true;
        }
      }
      Plotly.newPlot(
        this.chartEl.nativeElement,
        currentTraces,
        this.layout,
        this.config
      );
    }
  }

  toggleEventFlags(option: any) {
    this.showEventsFlags = option.checked;
    const traces = this.getTraces();

    let index = traces.findIndex((trace) => trace.txMeta.tagId === 0);
    if (index > -1) {
      (traces[index] as any).visible = option.checked;
    }
    Plotly.redraw(this.chartEl.nativeElement);
  }

  /**
   * Fetch train events
   * @param train train Object
   */
  fetchEvents(train: Train): void {
    this.starmsClient
      .get(["events/eventsoperationalsummary/trains", train.getId()], {
        from: this.timeRanges[this.timeRanges.length - 1].from,
        to: this.timeRanges[this.timeRanges.length - 1].to,
      })
      .subscribe(
        (events) => {
          const tracesNo = this.getTracesNumber();
          const flagsData = this.txServ.createFlagsData(events);
          this.activeRequests++;
          const eventsTrace = [
            {
              type: "scatter",
              mode: "markers",
              x: [...flagsData.map((t) => moment.utc(t.x).format())],
              y: [...flagsData.map((t) => 0)],
              marker: {
                size: [...flagsData.map((x) => 10)],
                symbol: [...flagsData.map((x) => x.symbol)],
              },
              line: {
                color: "black",
              },
              text: [...flagsData.map((x) => x.description)],
              hovertemplate: "%{x} %{text}",
              yaxis: `y`,
              txMeta: {
                tagId: 0,
              },
              showlegend: false,
              visible: this.showEventsFlags,
            },
          ];
          const traces = this.getTraces();

          let index = traces.findIndex((trace) => trace.txMeta.tagId === 0);
          if (index > -1) {
            let update = {
              x: [[...flagsData.map((t) => moment.utc(t.x).format())]],
              y: [[...flagsData.map((t) => 0)]],
            };
            this.activeRequests--;
            Plotly.update(
              this.chartEl.nativeElement,
              update,
              { "yaxis.tickvals": [] },
              index
            );
          } else {
            this.activeRequests--;
            Plotly.addTraces(
              this.chartEl.nativeElement,
              eventsTrace,
              tracesNo
            ) as Promise<any>;
          }
        },
        () => {}
      );
  }

  toggleRealTime() {
    this.realTimeEnabled = !this.realTimeEnabled;
  }

  resetZoom() {
    if (this.timeRanges.length >= 1) {
      this.timeRanges = [new TimeRange(1, "M")];
      this.selectedButton =
        this.timeRanges[0].interval.value + this.timeRanges[0].interval.type;
      this.applyTimeRange();
    }
  }

  close(): void {
    // this.activeModal.close();
  }
  drop(event) {}
}



// WEBPACK FOOTER //
// ./src/components/trend-explorer/trend-explorer.component.ts